import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ReferenceDataLabels } from '../../../../../lib/constants/reference-data-labels';
import { ReferenceDataOptionLists } from '../../../../../lib/constants/reference-data-option-lists';
import { BaseFormControlComponent } from '../../../../shared/components/form-inputs/base-form-control.component';
import { ReferenceDataService } from './../../../../../lib/services/reference-data.service';

@Component({
  selector: 'boi-form-option-list',
  templateUrl: './form-option-list.component.html',
  styleUrls: ['./form-option-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormOptionListComponent extends BaseFormControlComponent {
  @Input() public availableOptions: Array<any>;
  @Input() public forceNotRequired: boolean;
  @Input() public textField = 'Value';
  @Input() public valueField = 'Code';
  @Input() public hasDefaultItem = true;
  @Input() public isVirtualizationEnable = false;
  @Input() public optionList: string;

  public readonly referenceDataLabels = ReferenceDataLabels;
  public readonly referenceDataOptionLists = ReferenceDataOptionLists;
  public readonly virtualizationSettings = { itemHeight: 28, pageSize: 53 };

  private _defaultItem: any;
  @Input() public get defaultItem(): any {
    if (!this._defaultItem) {
      this.setDefaultItem();
    }

    return this._defaultItem;
  }

  public set defaultItem(defaultItem: any) {
    this._defaultItem = defaultItem;
  }

  constructor(private readonly referenceDataService: ReferenceDataService) {
    super();
  }

  private setDefaultItem(): any {
    if (this.hasDefaultItem) {
      this._defaultItem = this.optionList
        ? { Value: this.referenceDataService.getLocalizeLabel(ReferenceDataLabels.PleaseSelect), Code: undefined }
        : this.createDefaultItem();
    }
  }

  private createDefaultItem(): any {
    const defaultItem = {};
    defaultItem[this.textField] = this.referenceDataService.getLocalizeLabel(ReferenceDataLabels.PleaseSelect);
    defaultItem[this.valueField] = undefined;

    return defaultItem;
  }
}
